import React, {
  DetailedHTMLProps,
  ButtonHTMLAttributes,
  forwardRef,
} from 'react';
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import { CloseIcon } from '@stpkg/stand-react';
import classnames from 'classnames';

import styles from './index.module.css';

export type RSToastCloseButtonProps = Omit<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  'children'
>;

export const RSToastCloseButton = forwardRef<
  HTMLButtonElement,
  RSToastCloseButtonProps
>((props, ref) => {
  const { isFocusVisible, focusProps } = useFocusRing();

  const color = '#0066FF';

  return (
    <>
      <div
        className={classnames(
          'wrapper',
          isFocusVisible && 'focus-visible',
          'inline-block',
          'relative',
          'w-[36px]',
          'h-[36px]',
          'rounded-10',
          'before:transition',
        )}
      >
        <button
          {...mergeProps(props, focusProps)}
          ref={ref}
          className={classnames(
            'relative',
            'w-full',
            'h-full',
            'flex',
            'justify-center',
            'items-center',
            'bg-transparent',
            'border-none',
            'rounded-10',
            'outline-none',
            'focus:outline-none',
            'cursor-pointer',
            styles['button--default'],
          )}
        >
          <div>
            <CloseIcon
              width="16"
              height="16"
              viewBox="0 0 48 48"
              className="block fill-gray-400"
            />
          </div>
        </button>
      </div>
      <style jsx>{`
        .wrapper::before {
          content: '';
          box-sizing: border-box;
          position: absolute;
          width: calc(100% + 8px);
          height: calc(100% + 8px);
          top: -4px;
          left: -4px;
          border-style: solid;
          border-width: 2px;
          border-color: transparent;
          border-radius: 12px;
        }

        .wrapper.focus-visible::before {
          border-color: ${color};
        }
      `}</style>
    </>
  );
});

RSToastCloseButton.displayName = 'RSToastCloseButton';
